import { Link } from "react-router-dom";
import { Phone, Mail, Clock, Instagram, Facebook } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ug-detailing-shop/artifacts/tsv9bqsz_1.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ug-paper border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <img src={LOGO_URL} alt="UG-Detailing" className="h-12 w-auto" />
            <p className="text-gray-400 text-sm leading-relaxed">
              Driven by Detail, Powered by Passion. Wij zorgen voor de ultieme verzorging van uw voertuig.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-link"
                className="w-10 h-10 rounded-none bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary/50 transition-colors duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="facebook-link"
                className="w-10 h-10 rounded-none bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary/50 transition-colors duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6">
              Navigatie
            </h4>
            <ul className="space-y-3">
              {[
                { name: "Home", path: "/" },
                { name: "Diensten", path: "/diensten" },
                { name: "Producten", path: "/producten" },
                { name: "Offerte aanvragen", path: "/offerte" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-${link.name.toLowerCase().replace(' ', '-')}`}
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6">
              Diensten
            </h4>
            <ul className="space-y-3">
              {[
                "Leerbehandeling",
                "Dieptereiniging Stoelen",
                "Complete Interieurreiniging",
                "Ramencoating",
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/diensten"
                    className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <a
                  href="https://wa.me/31623861746"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-phone"
                  className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                >
                  06 23 86 17 46 (WhatsApp)
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                <a
                  href="mailto:umeyr@ug-detailing.com"
                  data-testid="footer-email"
                  className="text-gray-400 hover:text-white transition-colors duration-300 text-sm"
                >
                  umeyr@ug-detailing.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  Op afspraak
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} UG-Detailing. Alle rechten voorbehouden.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm transition-colors duration-300">
              Algemene Voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
